import {api} from '../../helpers';

function amlScreening({data, created_by}) {
  return api
    .post(`/users/kyc-dashboard/aml/screening`, data, {
      params: {created_by: created_by || 'Unknown User'},
    })
    .then(res => res.data);
}

function bulkScreening({data}) {
  return api.post(`/utils/api/aml/bulk`, data).then(res => res.data);
}

function fetchAllSearches({params}) {
  const {company_id, ...queryParams} = params;
  return api
    .get(`/utils/api/aml/search/${company_id}`, {params: queryParams})
    .then(res => res.data);
}

function amlExport({params}) {
  const {company_id, ...queryParams} = params;
  return api
    .get(`/utils/api/aml/search/${company_id}/export`, {params: queryParams})
    .then(res => res.data);
}

function fetchCompanyTitles({params}) {
  const {company_id, ...queryParams} = params;
  return api
    .get(`/utils/api/aml/titles/${company_id}`, {params: queryParams})
    .then(res => res.data);
}

function fetchSearchDetails({id}) {
  return api.get(`utils/api/aml/entity/${id}`).then(res => res.data);
}

function fetchSearchProfiles({id, ...queryParams}) {
  return api
    .get(`utils/api/aml/profiles/${id}`, {
      params: queryParams,
    })
    .then(res => res.data);
}

function fetchProfileDetails({id}) {
  return api.get(`utils/api/aml/profile/${id}`).then(res => res.data);
}

function updateMatchStatus({id, matchStatus, userName}) {
  return api
    .post(`utils/api/aml/entity/${id}/change-match-status`, {
      user: userName,
      match_status: matchStatus,
    })
    .then(res => res.data);
}

function updateRiskLevel({id, riskLevel, userName}) {
  return api
    .post(`utils/api/aml/entity/${id}/change-risk-level`, {
      user: userName,
      risk_level: riskLevel,
    })
    .then(res => res.data);
}

function updateAssignee({id, assignedTo, userName}) {
  return api
    .post(`utils/api/aml/entity/${id}/assign-to-user`, {
      user: userName,
      assigned_to: assignedTo,
    })
    .then(res => res.data);
}

export {
  amlScreening,
  fetchAllSearches,
  bulkScreening,
  fetchSearchProfiles,
  fetchProfileDetails,
  fetchSearchDetails,
  updateMatchStatus,
  updateRiskLevel,
  updateAssignee,
  amlExport,
  fetchCompanyTitles,
};
